import { Button, Content, Heading, IllustratedMessage, Inline, LinkButton } from "@hopper-ui/components";
import { InternalServerErrorIllustration as ChunkLoadErrorIllustration } from "@sg-protect/components";
import { reloadPage } from "@sg-protect/core";
import { useMemo } from "react";
import { useShellTranslation } from "../i18n/i18next.ts";
import { ErrorLayout } from "./ErrorLayout.tsx";

export function isChunkLoadError(error: unknown): boolean {
    return error instanceof Error && error.name === "ChunkLoadError";
}

export interface ChunkLoadErrorProps {
    variant?: "root" | "nested";
}

function handleBackButton() {
    window.history.back();
}

export function ChunkLoadError({ variant = "root" }: ChunkLoadErrorProps) {
    const { t } = useShellTranslation();

    const buttonMarkup = useMemo(
        () => (
            <Inline gap="inline-sm" marginTop="stack-md" alignX="center">
                {variant === "root" && window.history.length > 1 && (
                    <Button variant="secondary" onPress={handleBackButton}>
                        {t("ChunkLoadError.goBack")}
                    </Button>
                )}
                <LinkButton onPress={() => reloadPage()}>{t("ChunkLoadError.reload")}</LinkButton>
            </Inline>
        ),
        [variant, t]
    );

    return (
        <ErrorLayout variant={variant}>
            <IllustratedMessage size="lg">
                <ChunkLoadErrorIllustration />
                <Heading>{t("ChunkLoadError.title")}</Heading>
                <Content>{t("ChunkLoadError.description")}</Content>
            </IllustratedMessage>
            {buttonMarkup}
        </ErrorLayout>
    );
}
